import React, { useRef, useState } from 'react'
import AnimatedPage from '../../components/AnimatedPage'
import { BackButton } from '../../components/BackButton'
import styled from 'styled-components'
import Frame_Video from '../../assets/images/Frame_Video.png'
import Frame_Text from '../../assets/images/Frame_Text.png'
import Video1 from '../../assets/videos/Other_Select_Video_1.mp4'
import Video2 from '../../assets/videos/Other_Select_Video_2.mp4'
import { motion } from 'framer-motion'
import Pause_Icon from '../../assets/images/pause-button.png';
import Play_Icon from '../../assets/images/play-button.png';
import thumb1 from '../../assets/images/thumb1.jpg'
import thumb2 from '../../assets/images/thumb2.png'


export const OtherSelectPage = () => {
    const [isPlayingVideo1, setIsPlayingVideo1] = useState(false);
    const [showPlayIcon1, setShowPlayIcon1] = useState(false);
    const videoRef1 = useRef(null);
    const [isPlayingVideo2, setIsPlayingVideo2] = useState(false);
    const [showPlayIcon2, setShowPlayIcon2] = useState(false);
    const videoRef2 = useRef(null);


    const handleVideo1Click = () => {
        if (isPlayingVideo1) {
            videoRef1.current.pause();
            setIsPlayingVideo1(false);
        } else {
            // Pause other videos
            if (isPlayingVideo2) {
                videoRef2.current.pause();
                setIsPlayingVideo2(false);
                setShowPlayIcon2(false);
            }
            // Play current video
            videoRef1.current.play();
            setIsPlayingVideo1(true);
        }
        setShowPlayIcon1(true);
        setTimeout(() => setShowPlayIcon1(false), 1000);
    };

    const handleVideo2Click = () => {
        if (isPlayingVideo2) {
            videoRef2.current.pause();
            setIsPlayingVideo2(false);
        } else {
            // Pause other videos
            if (isPlayingVideo1) {
                videoRef1.current.pause();
                setIsPlayingVideo1(false);
                setShowPlayIcon1(false);
            }
            // Play current video
            videoRef2.current.play();
            setIsPlayingVideo2(true);
        }
        setShowPlayIcon2(true);
        setTimeout(() => setShowPlayIcon2(false), 1000);
    };

    return (
        <AnimatedPage animationType="fade">
            <BackButton />
            <Container>
                <VideoGroup>
                    <VideoBG onClick={handleVideo1Click}>
                        <ImgFrame src={Frame_Video} alt="" />
                        <StyledVideo
                            ref={videoRef1}
                            src={Video1}
                            poster={thumb1}
                            muted={false}
                        />
                        {showPlayIcon1 && (
                            <PlayIcon
                                as={motion.div}
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.2 }}
                            >
                                {isPlayingVideo1 ? <img src={Pause_Icon} alt="Pause" width={'60px'} height={'60px'} /> : <img src={Play_Icon} alt="Play" width={'60px'} height={'60px'} />}
                            </PlayIcon>
                        )}
                    </VideoBG>
                    <TextBG>
                        <img src={Frame_Text} alt="" width={'100%'} height={'100%'} style={{ position: 'absolute', top: 0, left: 0 }} />
                        <TextButton>
                            Một mã QR ai cũng có thể thanh toán
                        </TextButton>
                    </TextBG>
                </VideoGroup>
                <VideoGroup>
                    <VideoBG onClick={handleVideo2Click}>
                        <ImgFrame src={Frame_Video} alt="" />
                        <StyledVideo
                            ref={videoRef2}
                            src={Video2}
                            muted={false}
                            poster={thumb2}
                        />
                        {showPlayIcon2 && (
                            <PlayIcon
                                as={motion.div}
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.2 }}
                            >
                                {isPlayingVideo2 ? <img src={Pause_Icon} alt="Pause" width={'60px'} height={'60px'} /> : <img src={Play_Icon} alt="Play" width={'60px'} height={'60px'} />}
                            </PlayIcon>
                        )}
                    </VideoBG>
                    <TextBG>
                        <img src={Frame_Text} alt="" width={'100%'} height={'100%'} style={{ position: 'absolute', top: 0, left: 0 }} />
                        <TextButton>
                            thúc đẩy thanh toán không tiền mặt<br/> trong giao thông đô thị
                        </TextButton>
                    </TextBG>
                </VideoGroup>
            </Container>
        </AnimatedPage>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: calc(360 / 4096 * 100vw);
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: calc(120 / 2160 * 100vh) calc(320 / 4096 * 100vw) 0;
`;

const VideoGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
`;

const VideoBG = styled.div`
    height: ${props => `calc( ${props.height || 733} / 2160 * 100vh)`};
    width: ${props => `calc( ${props.width || 1380} / 4096 * 100vw)`};
    position: relative;
    cursor: pointer;
       background-color: #055200;
`;
const ImgFrame = styled.img`
  height: ${props => `calc( ${props.height || 1095} / 2160 * 100vh)`};
    width: ${props => `calc( ${props.width || 1616} / 4096 * 100vw)`};
    position: absolute;
    top: -20%;
    left: -9%;
    object-fit: fill;
`

const TextBG = styled.div`
   position: relative;
    margin-top: calc(220 / 2160 * 100vh);
    height: ${props => `calc( ${props.height || 164} / 2160 * 100vh)`};
    width: ${props => `calc( ${props.width || 1060} / 4096 * 100vw)`};
   background-color: #055200;
       align-items: center;
  justify-content: center;
    display: flex;
`;
const TextButton = styled.p`
font-size: ${props => `calc( ${props.size || 36} / 4096 * 100vw)`};
font-weight: 700;
color: white;
text-align: center;
    z-index: 10;
    margin-left: calc(20 / 2160 * 100vh);
        margin-right: calc(20 / 2160 * 100vh);
        text-transform: uppercase;

`;
const StyledVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 10px;
`;
const PlayIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 48px;
    color: white;
    padding: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    pointer-events: none;
    animation: fadeInOut 1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;

    @keyframes fadeInOut {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
`;
